<!-- Grid Principal do Faturamento Diário -->
<p-table [value]="dados" [scrollable]="true" scrollDirection="horizontal" scrollHeight="50vh"
  styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm style p-datatable-sticky-header" 
  [paginator]="false" [loading]="loading">
  
  <!-- COLGROUP -->
  <ng-template pTemplate="colgroup">
    <colgroup>
      <col *ngFor="let col of colunasFixasAtivas" [style.width.px]="col.width || 150" />
      <col *ngFor="let col of colunasDias" [style.width.px]="col.width || 80" />
      <col style="width: 100px" /> <!-- Coluna Total Faturamento -->
      <col style="width: 200px" /> <!-- Coluna Total Cancelados/Devolvidos -->
      <col style="width: 100px" /> <!-- Coluna Total Varejo -->
    </colgroup>
  </ng-template>

  <!-- HEADER -->
  <ng-template pTemplate="header">
    <tr>
      <!-- Colunas fixas (exceto total) -->
      <th *ngFor="let col of colunasFixasAtivas; let isFirst = first; trackBy: trackByColIndex" 
          style="text-align: left"
          [ngClass]="{'fixed-dealer-column': isDealerColumnFixed && col.field === 'name'}"
          [style.left.px]="isDealerColumnFixed && col.field === 'name' ? 0 : null">
        <div *ngIf="isFirst" class="d-flex align-items-center justify-content-between position-relative">
          <div class="d-flex align-items-center gap-2">
            <button type="button" 
                    class="btn btn-sm btn-outline-light btn-fix-dealer d-flex justify-content-center" 
                    (click)="toggleAllRegions()"
                    [title]="areAllRegionsExpanded() ? 'Recolher Todas' : 'Expandir Todas'">
              <i [class]="getHeaderIconClass()" 
                class="region-toggle-icon"
                title="Expandir/Recolher todas as regiões"></i>
            </button>
            <button type="button" 
                    class="btn btn-sm btn-outline-light btn-fix-dealer d-flex justify-content-center" 
                    (click)="toggleDealerColumnFixed()"
                    [title]="isDealerColumnFixed ? 'Desafixar Coluna Dealer' : 'Afixar Coluna Dealer'">
              <i [class]="getDealerColumnIconClass()" 
                class="region-toggle-icon"
                title="Afixar/Desafixar coluna dealer"></i>
            </button>
          </div>
          <span class="header-title-center">{{ col.header }}</span>
          <div class="header-spacer"></div>
        </div>
        <span *ngIf="!isFirst">{{ col.header }}</span>
      </th>
      
      <!-- Colunas dos dias -->
      <th *ngFor="let col of colunasDias; trackBy: trackByColIndex" 
          style="text-align: center">
        {{ col.header }}
      </th>
      
      <!-- Coluna Total -->
    <th style="text-align: center">Faturamento</th>
    <th style="text-align: center">Cancelados / Devolvidos</th>
    <th style="text-align: center">Varejo</th>
    </tr>
  </ng-template>

  <!-- BODY -->
  <ng-template pTemplate="body" let-dealer let-rowIndex="rowIndex">
    <tr [ngClass]="getRowClasses(dealer)" 
        [style.display]="shouldShowDealer(dealer, rowIndex) ? '' : 'none'">
      <!-- Colunas fixas (exceto total) -->
      <td *ngFor="let col of colunasFixasAtivas; let colIndex = index; trackBy: trackByColIndex" 
          style="text-align: left"
          [ngClass]="{'fixed-dealer-column': isDealerColumnFixed && col.field === 'name'}"
          [style.left.px]="isDealerColumnFixed && col.field === 'name' ? 0 : null">
        
        <!-- Total Regional com dropdown (somente primeira coluna) -->
        <div *ngIf="dealer.isTotalRegiao && colIndex === 0" class="region-total-header">
          <i  [class]="getRegionIconClass(dealer.regiao)" 
              (click)="toggleRegionCollapse(dealer.regiao)"
              class="region-toggle-icon"
              title="Expandir/Recolher região"
              role="button"></i>
          <strong class="region-title">{{ dealer[col.field] }}</strong>
        </div>
        
        <!-- Total Regional outras colunas -->
        <strong *ngIf="dealer.isTotalRegiao && colIndex > 0">{{ dealer[col.field] }}</strong>
        
        <!-- Dealer normal -->
        <span *ngIf="!dealer.isTotalRegiao">{{ dealer[col.field] }}</span>
      </td>

      <!-- Colunas dos dias -->
      <td *ngFor="let diaObj of diasDoMes; trackBy: trackByDia" 
          style="text-align: center"
          [ngClass]="{ 'clickable-cell': !dealer.isTotalRegiao }">
        <strong *ngIf="dealer.isTotalRegiao">{{ getDiaData(dealer, diaObj) }}</strong>
        <span *ngIf="!dealer.isTotalRegiao">{{ getDiaData(dealer, diaObj) }}</span>
      </td>

      <!-- Coluna Total -->
        <td style="text-align: center">
          <strong *ngIf="dealer.isTotalRegiao">{{ dealer.total }}</strong>
          <span *ngIf="!dealer.isTotalRegiao">{{ dealer.total }}</span>
        </td>
        <td style="text-align: center">
          <strong *ngIf="dealer.isTotalRegiao">{{ dealer.totalCancelDevol }}</strong>
          <span *ngIf="!dealer.isTotalRegiao">{{ dealer.totalCancelDevol }}</span>
        </td>
        <td style="text-align: center">
          <strong *ngIf="dealer.isTotalRegiao">{{ dealer.totalVarejo }}</strong>
          <span *ngIf="!dealer.isTotalRegiao">{{ dealer.totalVarejo }}</span>
        </td>
    </tr>
  </ng-template>

  <!-- FOOTER (TOTAL GERAL) -->
  <ng-template pTemplate="footer">
    <tr class="total-geral">
      <!-- Colunas fixas (exceto total) -->
      <td *ngFor="let col of colunasFixasAtivas; trackBy: trackByColIndex" 
          style="text-align: left"
          [ngClass]="{'fixed-dealer-column': isDealerColumnFixed && col.field === 'name'}"
          [style.left.px]="isDealerColumnFixed && col.field === 'name' ? 0 : null">
        <strong>TOTAL</strong>
      </td>
      
      <!-- Totais dos dias -->
      <td *ngFor="let diaObj of diasDoMes; trackBy: trackByDia" 
          style="text-align: center">
        <strong>{{ getValorTotalizador(diaObj.field) }}</strong>
      </td>

      <!-- Total Geral -->
        <td style="text-align: center">
          <strong>{{ getValorTotalizador('total') }}</strong>
        </td>
        <td style="text-align: center">
          <strong>{{ getValorTotalizador('totalCancelDevol') }}</strong>
        </td>
        <td style="text-align: center">
          <strong>{{ getValorTotalizador('totalVarejo') }}</strong>
        </td>
    </tr>
  </ng-template>
</p-table>